import React, { Component } from 'react';
import { Form, Input, Modal, Row, Col, Table } from 'antd';

import util from '@util';

const FormItem = Form.Item;
const { TextArea } = Input;
class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  columns = () => {
    return [
      {
        title: '流水编号',
        dataIndex: 'no',
        key: 'no',
        width: '15%',
      },
      {
        title: '预算组',
        dataIndex: 'groupName',
        key: 'groupName',
        width: '15%',
      },
      {
        title: '费用',
        dataIndex: 'price',
        key: 'price',
        width: '15%',
        render: text => {
          return <span>{util.numberFormat(text, 2, '.', ',')}</span>;
        },
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        key: 'remark',
        width: '20%',
      },
      {
        title: '分摊时间',
        dataIndex: 'time',
        key: 'time',
        width: '15%',
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        width: '10%',
        render: text => {
          if (text === 1) {
            return <span>未分摊</span>;
          }
          if (text === 3) {
            return <span>已分摊</span>;
          }
        },
      },
    ];
  };

  matchType = value => {
    let type = '';
    this.props.expendType.map(item => {
      if (item.value === value) {
        type = item.key;
        return type;
      }
      return item;
    });
    return type;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
    const formItemLayout2 = {
      labelCol: { span: 3 },
      wrapperCol: { span: 21 },
    };

    const { content } = this.props;

    return (
      <Modal title="预算分摊明细" visible width={700} onCancel={this.props.cancel} footer={false}>
        <Form>
          <Row gutter={25}>
            <Col span={12}>
              <FormItem label="分摊金额" {...formItemLayout}>
                {getFieldDecorator('price', {
                  rules: [{ required: true, message: '请输入账户名称' }],
                  initialValue: content.price,
                })(<Input disabled />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="预算科目" {...formItemLayout}>
                {getFieldDecorator('budgetType', {
                  rules: [{ required: true, message: '请选择收支方向' }],
                  initialValue: this.matchType(content.budgetType),
                })(<Input disabled />)}
              </FormItem>
            </Col>
          </Row>
          <FormItem label="说明" {...formItemLayout2}>
            {getFieldDecorator('remark', {
              rules: [{ required: true, message: '请选择预算类型' }],
              initialValue: content.remark,
            })(<TextArea rows={4} disabled />)}
          </FormItem>
        </Form>
        <Table
          dataSource={content.details || []}
          columns={this.columns()}
          bordered
          pagination={false}
          rowKey="uuid"
          size="small"
          scroll={{ y: '300' }}
        />
      </Modal>
    );
  }
}

export default Form.create()(IndexModal);



// WEBPACK FOOTER //
// ./src/components/finance/budget/check/ModalApportion.js